
const LanguageIcon = () => {
  return (
    <>
    <img src="/global.svg" />
    </>
  );
};

export default LanguageIcon;
